import React from "react";
import { Video, Clock, Heart } from "lucide-react";
import { ScrollAnimation } from "../ScrollAnimation";

const features = [
  { icon: Video, text: "Atendimento presencial e online" },
  { icon: Clock, text: "Mais de 30 anos de experiência clínica" },
  { icon: Heart, text: "Abordagem personalizada" },
];

export default function Intro() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="relative h-[400px] sm:h-[500px] lg:h-[600px]">
          <img
            src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/PHOTO-2026-04-14-22-34-35-JNvAN3GxBlebsgsB8NMEltKy6r7ED1.jpg"
            alt="Mulher em paz na natureza"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-[#f8f6f1] hidden lg:block" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#f8f6f1] via-transparent to-transparent lg:hidden" />
        </div>

        <div className="relative bg-[#f8f6f1] flex items-center">
          <div className="w-full px-6 sm:px-10 lg:px-16 py-12 lg:py-0">
            <ScrollAnimation animation="fade-left" delay={200}>
              <p className="font-serif text-lg sm:text-xl md:text-2xl text-[#4a4a4a] leading-relaxed mb-10 max-w-lg">
                Na <span className="text-[#204613] font-semibold">Mesquita Psiquiatria e Psicoterapia</span>, você encontra um cuidado integral em saúde mental, onde ciência e sensibilidade se unem para transformar dor em <span className="text-[#C2A44A] font-semibold">equilíbrio emocional</span> e <span className="text-[#C2A44A] font-semibold">liberdade interior</span>.
              </p>
            </ScrollAnimation>

            <div className="flex flex-col gap-5">
              {features.map((feature, idx) => {
                const Icon = feature.icon;
                return (
                  <ScrollAnimation key={idx} animation="fade-up" delay={300 + idx * 100}>
                    <div className="flex items-center gap-4 group">
                      <div className="w-12 h-12 rounded-full bg-[#ACC996]/20 border border-[#ACC996]/40 flex items-center justify-center group-hover:bg-[#ACC996]/30 group-hover:scale-110 transition-all duration-300">
                        <Icon className="w-5 h-5 text-[#204613]" />
                      </div>
                      <span className="font-sans text-base sm:text-lg font-medium text-[#204613]">
                        {feature.text}
                      </span>
                    </div>
                  </ScrollAnimation>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
